import { ControlOptions, data } from 'azure-maps-control'
import { AuthenticationType, IAzureMapControls, IAzureMapOptions } from 'react-azure-maps'

/**
 * Azure maps options
 */
const mapOptions: IAzureMapOptions = {
  authOptions: {
    authType: AuthenticationType.subscriptionKey,
  },
  // Arbitrary values (Center of France). Center and zoom should be computed from the data
  center: new data.Position(4.56144, 46.6776),
  zoom: 1,
  // Map style. Default is 'road'. Availables styles : https://learn.microsoft.com/fr-fr/azure/azure-maps/supported-map-styles
  style: 'road',
  // Map localization view. Default is 'Auto'.
  view: 'Auto',
  language: 'fr',
  enableAccessibility: true,
  showLogo: false,
  progressiveLoading: true,
  antialiasing: true,
  dragRotateInteraction: false,
}

/**
 * Map controls
 */
const mapControls: IAzureMapControls[] = [
  {
    controlName: 'StyleControl',
    controlOptions: {
      mapStyles: [
        'road',
        'satellite_road_labels',
        'grayscale_dark',
        'grayscale_light',
        'high_contrast_dark',
        'high_contrast_light',
        'night',
        'road',
        'road_shaded_relief',
      ],
    },
    options: { position: 'bottom-left' } as ControlOptions,
  },
  {
    controlName: 'ZoomControl',
    options: { position: 'bottom-right' } as ControlOptions,
  },
]

export { mapControls, mapOptions }
